import React from 'react';
import HR from '../../Components/HR';

const CaseStudies = () => {
    return (
        <div className='mb-20 mt-10' id='Benefits'>
            <HR>Sample Case Studies</HR>
            <div className='grid gap-8 lg:grid-cols-12 md:w-10/12 mt-10'>
                <div className='lg:col-span-5 bg-secondaryBG text-grayBG text-xl rounded-3xl'>
                    <p className='p-5 mb-20'>Automation of AR Reconciliation 7 FTE days per month to 2 hours.</p>
                </div>
                <div className='lg:col-span-5 bg-secondaryBG text-grayBG text-xl rounded-3xl'>
                    <p className='p-5 mb-20'>Automation of AR Reconciliation 7 FTE days per month to 2 hours.</p>
                </div>
                <div className='lg:col-span-5 bg-secondaryBG text-grayBG text-xl rounded-3xl'>
                    <p className='p-5 mb-20'>Automation of AR Reconciliation 7 FTE days per month to 2 hours.</p>
                </div>
                <div className='lg:col-span-5 bg-secondaryBG text-grayBG text-xl rounded-3xl'>
                    <p className='p-5 mb-20'>Automation of AR Reconciliation 7 FTE days per month to 2 hours.</p>
                </div>
            </div>
        </div>
    );
};

export default CaseStudies;